import React, { useState } from 'react';
import { getTheme, setTheme } from '../utils/themeInit';

export default function ThemeToggle() {
  const [theme, setT] = useState(getTheme());
  const flip = () => {
    const next = theme === 'dark' ? 'light' : 'dark';
    setTheme(next);
    setT(next);
  };
  return (
    <button
      type="button"
      onClick={flip}
      aria-label={theme === 'dark' ? 'Switch to light mode' : 'Switch to dark mode'}
      title={theme === 'dark' ? 'Light mode' : 'Dark mode'}
      style={{
        width: 38, height: 38, borderRadius: 'var(--radius-sm)', border: '1px solid var(--color-border)',
        background: 'var(--color-surface)', color: 'var(--color-text-primary)', cursor: 'pointer', fontSize: 17, flexShrink: 0,
      }}
    >
      {theme === 'dark' ? '☀' : '☾'}
    </button>
  );
}
